import type { IntegrationRequestFormSchema } from '../../../models/IntegrationRequest';
import type { UseFormSetValue } from 'react-hook-form';
import { useEffect, useRef } from 'react';

interface UseOperatorChangeResetProps {
  logisticOperatorId: string;
  setValue: UseFormSetValue<IntegrationRequestFormSchema>;
}

const useOperatorChangeReset = ({
  logisticOperatorId,
  setValue,
}: UseOperatorChangeResetProps) => {
  const previousOperatorId = useRef(logisticOperatorId);

  useEffect(() => {
    if (previousOperatorId.current && previousOperatorId.current !== logisticOperatorId) {
      setValue('serviceWithOperatorIds', []);
    }
    previousOperatorId.current = logisticOperatorId;
  }, [logisticOperatorId, setValue]);
};

export default useOperatorChangeReset;
